const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20young%20Chinese%20man%20in%20casual%20style%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression%2C%20modern%20professional%20look&width=80&height=80&seq=avatar-comment-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个黑料在线平台太绝了！每天都有最新的大瓜，黑料在线观看体验一流，画质清晰不卡顿，真心推荐给所有吃瓜群众。',
    likes: 1286,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20natural%20makeup%2C%20approachable%20look&width=80&height=80&seq=avatar-comment-02&orientation=squarish',
    name: '深夜吃瓜人',
    time: '5小时前',
    content: '终于找到一个靠谱的黑料在线播放平台！更新速度真的快，爆料内容也实锤，不像其他网站全是假瓜。黑料在线免费观看太香了。',
    likes: 956,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20Chinese%20man%20in%20his%2030s%2C%20confident%20expression%2C%20clean%20white%20background%2C%20soft%20even%20lighting%2C%20modern%20business%20casual&width=80&height=80&seq=avatar-comment-03&orientation=squarish',
    name: '娱乐圈观察员',
    time: '8小时前',
    content: '作为老吃瓜人了，这个站的黑料视频质量确实高。在线观看黑料不卡顿，还不用注册，保护隐私这点很赞。',
    likes: 723,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20bright%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20natural%20beauty%2C%20friendly&width=80&height=80&seq=avatar-comment-04&orientation=squarish',
    name: '八卦小能手',
    time: '12小时前',
    content: '黑料在线视频资源太丰富了！娱乐圈、网红圈全都有，每天上班摸鱼就靠黑料在线观看了，同事们都在用。',
    likes: 541,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20headshot%20portrait%20of%20a%20Chinese%20man%20in%20casual%20wear%2C%20warm%20expression%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20relaxed%20vibe&width=80&height=80&seq=avatar-comment-05&orientation=squarish',
    name: '瓜田里的守望者',
    time: '1天前',
    content: '黑料在线免费观看这点我必须吹爆！之前那些网站动不动就要付费，这里全是免费的，黑料在线播放画质还高。',
    likes: 398,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-secondary-500 rounded-lg">
            <i className="ri-chat-3-line text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">网友热评</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">真实用户反馈 · 看看大家对黑料在线怎么说</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((comment, i) => (
            <div key={i} className="p-5 rounded-lg bg-background-100 border border-background-200/60">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-900 truncate">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}